<template src="./template.html"></template>

<script setup>
import { onMounted } from "vue"
import { usePayment, paymentManager } from "@/composables/usePayment"

const { proceedToPayment } = usePayment()

onMounted(() => {
  paymentManager.register({
    init: proceedToPayment,
  })
})
</script>
